import { render } from "./SubdomainLink.vue?vue&type=template&id=2b9aa9f8"
import script from "./SubdomainLink.vue?vue&type=script&lang=js"
export * from "./SubdomainLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/oneaudiobooksapp.on-forge.com/releases/80963304/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__